var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 11.653,
    height: 18.473,
    viewBox: "0 0 11.653 18.473",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "phone-icon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.653,
    height: 18.473,
    fill: "current"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    ransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)",
    clipPath: "url(#phone-icon)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.467.012H8.006A.988.988,0,0,0,7.894,0H3.759a.977.977,0,0,0-.112.012H2.187A2.189,2.189,0,0,0,0,2.2V16.286a2.189,2.189,0,0,0,2.187,2.186h7.28a2.189,2.189,0,0,0,2.186-2.186V2.2A2.189,2.189,0,0,0,9.467.012m1.147,16.275a1.148,1.148,0,0,1-1.147,1.147H2.187A1.149,1.149,0,0,1,1.04,16.286V2.2A1.149,1.149,0,0,1,2.187,1.051h.568a1.007,1.007,0,0,0,1,.968H7.894a1.007,1.007,0,0,0,1-.968h.568A1.148,1.148,0,0,1,10.613,2.2Z",
    transform: "translate(0 0)",
    fill: "current"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.a35bf2939a9c85873c8031252b3352ca.svg";
export { ForwardRef as ReactComponent };